module.exports = __webpack_public_path__ + "img/visa.87132014.svg";